import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    let swiperContainer = element.querySelector('.partners-swiper');
    let swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    let slides = swiperContainer.querySelectorAll('.swiper-slide');

    const swiperOptions = {
        modules: [Autoplay, Navigation],
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: data.transition ? data.transition : 300,
        loop: true,
        autoplay: data.timeout ? {delay: data.timeout} : false,
        navigation: {
            nextEl: element.querySelector(".swiper-button-next"),
            prevEl: element.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
            1500: {
                spaceBetween: 53,
            },
            992: {
                spaceBetween: 40,
            },
            768: {
                spaceBetween: 30,
            }
        }
    };

    // if (slides.length > 1 && slides.length < 12) {
    //     const originalSlides = Array.from(slides); 

    //     while (swiperWrapper.querySelectorAll('.swiper-slide').length < 12) {
    //         originalSlides.forEach(slide => {
    //             if (swiperWrapper.querySelectorAll('.swiper-slide').length >= 12) return;
    //             const cloneSlide = slide.cloneNode(true);
    //             swiperWrapper.appendChild(cloneSlide);
    //         });
    //     }
    // }

    let spaceBetween = swiperOptions.spaceBetween ?? 0;

    let totalSlidesWidth = Array.from(slides).reduce((sum, slide) => {
        return sum + slide.offsetWidth + spaceBetween;
    }, 0);

    let containerWidth = swiperContainer.clientWidth;

    if (slides.length > 1 && totalSlidesWidth < containerWidth * 2.2) {
        let originalSlides = Array.from(slides);

        let currentWidth = totalSlidesWidth;
        while (currentWidth < containerWidth * 2.2) {
            for (const slide of originalSlides) {
                const clone = slide.cloneNode(true);
                swiperWrapper.appendChild(clone);
                currentWidth += slide.offsetWidth + spaceBetween;

                if (currentWidth >= containerWidth * 2.2) break;
            }
        }
    }

    setTimeout(() => {
        element.swiper = new Swiper(swiperContainer, swiperOptions);
    }, 300);
}
